import Clean from './Clean';
import Clouds from './Clouds';
import Solid from './Solid';

export default function SkinComponent({ skin, ...restProps }) {
    switch(skin) {
        case 'clean':
            return <Clean {...restProps} />;
        case 'clouds':
            return <Clouds {...restProps} />;
        case 'solid':
            return <Solid {...restProps} />;
        default:
            return <Clean {...restProps} />;
    }
}
